import React from "react";
import ReactEcharts from "echarts-for-react";
import { Grid, Paper } from "@mui/material";

const LoanAnalyticsCharts = ({ data }) => {
  if (!data) return null;
  const legendValueMap = {
    Pending: data.pending_applications,
    Completed: data.completed_applications,
    Approved: data.approved_applications,
    Rejected: data.rejected_applications,
    Sanctioned: data.sanctioned_applications,
    Disbursed: data.disbursed_applications,
  };

  const loanApplications = {
    title: {
      text: "Loan Applications Distribution",
      left: "center",
      top: "2%",
      textStyle: { fontSize: 14, fontWeight: 600, color: "#333" },
    },
    tooltip: {
      trigger: "item",
      formatter: (p) => `${p.name}: ${p.value} (${p.percent}%)`,
    },

    legend: {
      orient: "vertical",
      left: "1%",
      top: "middle",
      formatter: (name) => {
        const value = legendValueMap[name] ?? 0;
        return `${name} - ${value}`;
      },
      textStyle: {
        color: "#111827",
        fontWeight: 500,
        fontSize: 13,
      },
    },
    series: [
      {
        name: "Applications",
        type: "pie",
        radius: ["40%", "68%"],
        center: ["58%", "55%"],
        label: {
          show: true,
          position: "outside",
          formatter: "{b}",
          color: "#1f2937",
          fontWeight: 500,
        },
        emphasis: { label: { show: true, fontSize: 13, fontWeight: 600 } },
        labelLine: { show: true },
        data: [
          { value: data.pending_applications, name: "Pending" },
          { value: data.completed_applications, name: "Completed" },
          { value: data.approved_applications, name: "Approved" },
          { value: data.rejected_applications, name: "Rejected" },
          { value: data.sanctioned_applications, name: "Sanctioned" },
          { value: data.disbursed_applications, name: "Disbursed" },
        ],
        itemStyle: {
          borderRadius: 6,
          borderColor: "#fff",
          borderWidth: 2,
        },
        color: [
          "#FFA726",
          "#81C784",
          "#4CAF50",
          "#E57373",
          "#29B6F6",
          "#BA68C8",
        ],
      },
    ],
  };

  const loanAmounts = {
    title: {
      text: "Loan Amount Flow (₹)",
      left: "center",
      top: "2%",
      textStyle: { fontSize: 14, fontWeight: 600, color: "#333" },
    },
    tooltip: {
      trigger: "axis",
      formatter: (params) =>
        `${params[0].name}<br/>₹${params[0].value.toLocaleString("en-IN")}`,
    },
    grid: {
      top: "18%",
      left: "8%",
      right: "8%",
      bottom: "12%",
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      data: ["Requested", "Approved", "Sanctioned", "Disbursed"],
      axisLabel: { fontSize: 12 },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (v) =>
          v >= 10000000 ? `${(v / 10000000).toFixed(1)} Cr` : v,
        fontSize: 12,
      },
      splitLine: { lineStyle: { color: "#eee" } },
    },
    series: [
      {
        name: "Loan Amount",
        type: "line",
        smooth: true,
        data: [
          data.total_loan_amount_requested,
          data.total_loan_amount_approved,
          data.total_loan_amount_sanctioned,
          data.total_loan_amount_disbursed,
        ],
        symbol: "circle",
        symbolSize: 7,
        lineStyle: { width: 3, color: "#4CAF50" },
        itemStyle: {
          color: "#4CAF50",
          borderColor: "#fff",
          borderWidth: 2,
        },
        areaStyle: { color: "rgba(76, 175, 80, 0.15)" },
      },
    ],
  };

  return (
    <Grid container spacing={2} sx={{ mb: 3 }}>
      <Grid item xs={12} md={6}>
        <Paper
          elevation={2}
          sx={{ p: 2, borderRadius: 3, backgroundColor: "#fff" }}
        >
          <ReactEcharts option={loanApplications} style={{ height: 320 }} />
        </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper
          elevation={2}
          sx={{ p: 2, borderRadius: 3, backgroundColor: "#fff" }}
        >
          <ReactEcharts option={loanAmounts} style={{ height: 320 }} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default LoanAnalyticsCharts;
